import { Table } from '@aws-amplify/ui-react'
import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Options } from 'components/Options/Options'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import { setConfirmModal } from 'features/global/globalSlice'
import { clearCostCenter, deleteCostCenterItem, getCostCenterItems } from 'features/inventory/inventoryCostCenterSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { Button, Flex, MainHeadline, PageFooter, PageWrapper, Th, Tr } from 'styling/GlobalStyles'
import { IGetAllCostCenterItemsSingleResponse } from 'types/api/inventoryCostCenterApi.interface'
import { ModalTypes } from 'types/global.interface'
import { getParams, handlePagination } from 'utils/helpers'
import { IInventoryCostCenterModal, InventoryCostCenterModal } from './InventoryCostCenterModal'

export const InventoryCostCenter = () => {
    const dispatch = useDispatch<AppDispatch>()
    const { costCenterItems, totalPages } = useSelector((store: RootState) => store.inventoryCostCenter)
    const [params, setParams] = useState<any>(getParams({ location }))
    const [modal, setModal] = useState({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getCostCenterItems], cleanUpFunctions: [clearCostCenter], params })

    const transformDataForModal = (item: IGetAllCostCenterItemsSingleResponse): IInventoryCostCenterModal => {
        return {
            id: item.id,
            name: item.name,
            code: item.code,
            ownerUser: {
                value: item.ownerUser.id,
                label: item.ownerUser.firstName + ' ' + item.ownerUser.lastName
            }
        }
    }

    const removeRecord = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteCostCenterItem(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: costCenterItems.length < 2,
                },
                word: 'delete record',
            }),
        )
    }

    return <>
        <NavBar input setParams={setParams} placeholder='Search...' />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Cost Center</MainHeadline>
                <Button orange onClick={() => setModal({ open: true, value: null })} >
                    Add Record
                </Button>
            </Flex>
            {!costCenterItems.length ? (
                <NoItems title='Records' />
            ) : (
                <Table width='100%' >
                    <Th>
                        <Td w='20%' noTooltip text='NAME' />
                        <Td w='20%' noTooltip text='CODE' />
                        <Td w='55%' noTooltip text='OWNER' />
                        <Td w='5%' />
                    </Th>
                    {costCenterItems.map((item) => {
                        return (
                            <Tr key={item.id}>
                                <Td w='20%' text={item.name} />
                                <Td w='20%' text={item?.code} />
                                <Td w='55%' text={item?.ownerUser.firstName + ' ' + item?.ownerUser.lastName} />
                                <Td options w='5%'>
                                    <Options item={item} title='Cost Center' openModal={() => setModal({ open: true, value: transformDataForModal(item) })} handleRemove={removeRecord} />
                                </Td>
                            </Tr>
                        )
                    })}
                </Table>
            )}
            {modal.open && <InventoryCostCenterModal closeModal={() => setModal({ open: false, value: null })} value={modal.value} />}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}